// extracted by mini-css-extract-plugin
module.exports = {"complete":"style__complete__IyTg-","inProgress":"style__inProgress__zCvZH","notStarted":"style__notStarted__wjck7","pad":"style__pad__Kmskm"};